import styled from "styled-components";
import { comum } from "../../../../../../styles/Themes/light";
import { StylesConfig, ThemeConfig, ControlProps } from 'react-select';

export const OutrasPartesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 16px;
    border-top: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};
`;

export const OutrasPartesTitulo = styled.h4`
    font-size: 0.75rem;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.c6b7280};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 16px 0;
`;

export const OutrasPartesGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;

    @media (min-width: 1024px) {
        grid-template-columns: 1fr 1fr;
        gap: 24px;
    }
`;

export const SecaoPartes = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SecaoTitulo = styled.h5`
    font-size: 0.75rem;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.c1f2937};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0;
`;

export const OutrasPartes = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;

    @media (min-width: 1520px) {
        grid-template-columns: 1fr 1fr;
        gap: 24px;
    }

    > div {
        display: flex;
        flex-direction: column;
    }

    .label {
        font-size: 0.75rem;
        font-weight: 500;
        color: ${(props: any) => props.theme.colors.c1f2937};
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-bottom: 16px;
        display: block;
    }
    
    .nao-encontrado {
        font-size: 0.875rem;
        color: ${(props: any) => props.theme.colors.c718096};
        font-style: italic;
        padding: 16px 20px;
        text-align: center;
        background-color: ${(props: any) => props.theme.colors.cf3f7fb};
        border-radius: 8px;
        border: 1px dashed ${(props: any) => props.theme.colors.ccbd5e0};
        margin-top: 12px;
    }
`;

export const FieldRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 8px;
    align-items: end;
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};
    margin-bottom: 0;

    @media (max-width: 1350px) {
        grid-template-columns: 1fr;
    }
`;

export const FieldRowNomeBotao = styled.div`
    display: flex;
    gap: 8px;
    align-items: end;
`;

export const FieldRowRepresentada = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};
    margin-bottom: 0;
`;

export const Label = styled.label`
    display: block;
    font-size: 0.75rem;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.c1f2937};
    margin-bottom: 4px;
`;

export const Input = styled.input`
    width: 100%;
    height: 32px;
    padding: 6px 12px;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
    border-radius: 6px;
    font-size: 0.75rem;
    color: ${(props: any) => props.theme.colors.interfaceText500};
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    transition: border-color 0.2s ease;

    &::placeholder { 
        color: ${(props: any) => props.theme.colors.ca0aec0}; 
    }
    
    &:hover {
        border: 1px solid ${(props: any) => props.theme.colors.c000000};
    }

    &:focus {
        border: 1px solid ${(props: any) => props.theme.colors.c000000};
        outline: none;
    }
`;

export const selectStyles: StylesConfig<{ value: string; label: string }, false> = {
    control: (provided: Record<string, unknown>, state: ControlProps<{ value: string; label: string }, false>) => ({
        ...provided,
        height: 32,
        minHeight: 32,
        boxShadow: "none",
        cursor: 'pointer',
        border: state.hasValue && (state.selectProps as { error?: boolean }).error 
            ? `1px solid ${comum.colors.primaryRed400}` 
            : '1px solid #EAEEF3',
        transition: 'border-color 0.2s ease',
        '&:hover': {
            border: '1px solid #000000',
        },
        '&:focus': {
            border: '1px solid #000000',
        },
    }),
    valueContainer: (provided: Record<string, unknown>) => ({
        ...provided,
        padding: '0 12px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (provided: Record<string, unknown>) => ({
        ...provided,
        margin: 0,
        padding: 0,
        height: 'auto',
    }),
    indicatorsContainer: (provided: Record<string, unknown>) => ({
        ...provided,
        height: '30px',
        padding: '0 8px',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (provided: Record<string, unknown>) => ({
        ...provided,
        padding: '4px',
    }),
    placeholder: (provided: Record<string, unknown>) => ({
        ...provided,
        color: 'var(--c353a40)',
        fontSize: '0.75rem',
        fontWeight: '400',
        margin: 0,
    }),
    singleValue: (provided: Record<string, unknown>) => ({
        ...provided,
        color: 'var(--c353a40)',
        fontSize: '0.75rem',
        margin: 0,
    }),
    option: (provided: Record<string, unknown>) => ({
        ...provided,
        color: 'var(--c5a646e)',
        fontSize: '14px',
        fontWeight: '500',
    }),
    menu: (provided: Record<string, unknown>) => ({
        ...provided,
        zIndex: 1000,
    }),
    menuPortal: (provided: Record<string, unknown>) => ({
        ...provided,
        zIndex: 1000,
    }),
};

export const selectTheme: ThemeConfig = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: comum.colors.interfacePure100,
        primary50: comum.colors.interfacePure100,
        primary: comum.colors.interfacePure100,
    },
});

export const selectComponents = {
    IndicatorSeparator: () => null
};

export const AddButton = styled.button<{disabled?: boolean}>`
    height: 32px;
    width: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    opacity: 1;

    &:hover:not(:disabled) {
        background-color: ${(props: any) => props.theme.colors.cd41e35};
    }

    &:disabled {
        background-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 0.6;
        transform: none;
    }
    
    svg {
        color: inherit;
        stroke: currentColor;
        fill: none;
    }
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

// IconContainer component for partes do processo
export const IconContainer = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${(props: any) => props.theme.colors.cf3f4f6};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const ParteInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 0;
    
    span {
        font-size: 0.875rem;
        color: ${(props: any) => props.theme.colors.c1f2937};
    }
`;

export const ListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px;
    background-color: ${(props: any) => props.theme.colors.cf9fafb};
    border: none;
    border-radius: 8px;
    min-height: 60px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
`;

export const IconContainerRepresentada = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${(props: any) => props.theme.colors.cdcfce7};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const ParteInfoRepresentada = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 0;
    
    span {
        font-size: 0.875rem;
        color: ${(props: any) => props.theme.colors.c1f2937};
    }
`;

export const ListItemRepresentada = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px;
    background-color: ${(props: any) => props.theme.colors.cf0fdf4};
    border: none;
    border-radius: 8px;
    min-height: 60px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const CustomCheckbox = styled.div<{ checked: boolean }>`
    width: 16px;
    height: 16px;
    border: 1px solid ${props => props.checked ? 'var(--ce52940)' : 'var(--cd1d5db)'};
    border-radius: 4px;
    background-color: ${props => props.checked ? 'var(--ce52940)' : 'var(--surface-input)'};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
    
    &::before {
        content: "✓";
        color: ${(props: any) => props.theme.colors.pureWhite};
        font-size: 12px;
        font-weight: bold;
        opacity: ${props => props.checked ? 1 : 0};
        transition: opacity 0.2s;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 1;
    }
    
    &:hover {
        border-color: ${props => props.checked ? 'var(--cd41e35)' : 'var(--c9ca3af)'};
    }
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    position: relative;
    
    span {
        color: ${(props: any) => props.theme.colors.c6b7280};
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1;
        flex-shrink: 0;
    }
`;

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const Tooltip = styled.div`
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'};
    color: ${({ theme }) => theme.colors?.interfacePure0 || '#fff'};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.18);
    z-index: 20;
    pointer-events: none;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 6px;
        border-style: solid;
        border-color: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'} transparent transparent transparent;
    }
`;

export const DeleteButton = styled.button<{disabled?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background-color: transparent;
    color: ${props => props.disabled ? props.theme.colors.disabledBg : 'var(--cdc2626)'};
    border: none;
    border-radius: 6px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background-color: ${(props: any) => props.theme.colors.cfef2f2};
        color: ${(props: any) => props.theme.colors.cdc2626};
    }
    
    &:disabled {
        background-color: transparent;
        color: ${({ theme }) => theme.colors.disabledBg};
        cursor: not-allowed;
    }

    svg {
        width: 16px;
        height: 16px;
    }

    svg path {
        stroke: currentColor;
        fill: none;
    }
`;

export const Badge = styled.span<{ variant?: 'representada' | 'vinculada' }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background-color: ${props => props.variant === 'vinculada' ? 'var(--cfdf2f2)' : 'rgb(219, 234, 254)'};
    color: ${props => props.variant === 'vinculada' ? 'var(--ce52940)' : 'rgb(28, 64, 175)'};
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 500;
    border: none;
`;

export const SaveButton = styled.button`
    height: 36px;
    padding: 0 16px;
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    border: none;
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${(props: any) => props.theme.colors.cd41e35};
        transform: scale(1.05);
    }
`;

export const CancelButton = styled.button`
    height: 36px;
    padding: 0 16px;
    background-color: ${(props: any) => props.theme.colors.ce2e8f0};
    color: ${(props: any) => props.theme.colors.c2d3748};
    border: none;
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${(props: any) => props.theme.colors.ccbd5e0};
    }
`;
